const usageSummaryDataReducer = (state = null, action) => {
    switch (action.type) {
      case 'FETCH_USAGE_SUMMARY_DATA_SUCCESS':
        return {
          ...state,
          data:  action.payload
        };
      case 'FETCH_USAGE_SUMMARY_DATA_FAILED':
        return {
          ...state,
          failed: true    
        };
      default: 
        return state;
    }
  }
  
  export default usageSummaryDataReducer;
  